import { SmartTable } from '@certemy/ui-components';
import { VouchersListActions, VouchersActionMessages } from './vouchers-list.interface';

export enum VOUCHERS_STATUS {
  DRAFT,
  ACTIVE,
}

export class VouchersListFilters {
  page = 1;
  search = '';
  orderId = 'updatedAt';
  orderType = SmartTable.Order.DESC;
  order: SmartTable.OrderedHeader;
  filters = {
    publishedStatuses: [VOUCHERS_STATUS.ACTIVE],
  };
}

export const VOUCHERS_STATUS_NAME = {
  [VOUCHERS_STATUS.ACTIVE]: 'Active',
  [VOUCHERS_STATUS.DRAFT]: 'Draft',
};

export const defaultVouchersListTableData = {
  rows: [],
  count: 0,
};

export const VOUCHERS_CHECKBOX_GROUP_FILTER = {
  name: 'publishedStatuses',
  label: 'Status',
  defaultValue: { [VOUCHERS_STATUS.ACTIVE]: true },
  options: [
    { id: VOUCHERS_STATUS.DRAFT, name: VOUCHERS_STATUS_NAME[0] },
    { id: VOUCHERS_STATUS.ACTIVE, name: VOUCHERS_STATUS_NAME[1] },
  ],
};

export const VOUCHERS_LIST_ACTIONS: VouchersListActions = {
  ADD: { type: 'Add', name: 'Add Vouchers' },
  COPY: { type: 'Copy', name: 'Copy Vouchers' },
  DELETE: { type: 'Delete', name: 'Delete Vouchers' },
};

export const VOUCHERS_ACTION_MESSAGES: VouchersActionMessages = {
  [VOUCHERS_LIST_ACTIONS.ADD.type]: { error: '', success: '' },
  [VOUCHERS_LIST_ACTIONS.DELETE.type]: {
    error: 'Please select Vouchers to delete',
    success: 'Voucher(s) successfully deleted',
  },
  [VOUCHERS_LIST_ACTIONS.COPY.type]: {
    error: 'Please select Vouchers to copy',
    success: 'Voucher(s) successfully copied',
  },
};
